import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';

// eslint-disable-next-line import/prefer-default-export
export const ColProductCalloutStyled = styled(Col)`
  ${({ theme, disableBottomMargin }) => {
    const largeUp = theme.largeUp();
    const mediumUp = theme.mediumUp();
    let thisMarginBottom = rem(12);

    if(largeUp || disableBottomMargin){
      thisMarginBottom = 0;
    } else if(mediumUp){
      thisMarginBottom = rem(16);
    }

    return css`
      margin-bottom: ${thisMarginBottom};
    `;
  }}
`;
